module.exports = __webpack_public_path__ + "img/buni-token-color.ac4726c1.svg";